import { render, staticRenderFns } from "./OrganismTicketReplyTemplateDataManagement.vue?vue&type=template&id=618f86f0&scoped=true&"
import script from "./OrganismTicketReplyTemplateDataManagement.vue?vue&type=script&lang=js&"
export * from "./OrganismTicketReplyTemplateDataManagement.vue?vue&type=script&lang=js&"
import style0 from "./OrganismTicketReplyTemplateDataManagement.vue?vue&type=style&index=0&id=618f86f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618f86f0",
  null
  
)

export default component.exports